import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axios } from '../../lib/axios';
import { LOCATION_KEY } from '../../lib/constants';
import { AxiosErrorResponse } from '../../lib/types';

import { Location } from './index';

export const getOneOwner = (id: number | null): Promise<Location> | null => {
  if (id === null || isNaN(id)) return null;
  return axios.get(`/location/${id}`);
};

export const useOneLocation = (id: number) => {
  return useQuery<Location | null, AxiosError<AxiosErrorResponse>>({
    queryKey: [LOCATION_KEY, id],
    queryFn: () => getOneOwner(id),
    keepPreviousData: true,
  });
};
